import { Container, makeStyles } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { postCandidate } from '../../../api/candidate';
//import DeleteModal from '../../../components/deleteModal';
import Education from '../../../components/education';
import Experiences from '../../../components/experiences';
//import Introduce from '../../../components/introduce';
//import Loader from '../../../components/loader';
import Overview from '../../../components/overview';
import Quotes from '../../../components/quotes';
import Skills from '../../../components/skills';
import { COLORS } from '../../../constants/colors';
//import useFetch from '../../../hooks/useFetch';
import useNotifications from '../../../hooks/useNotification';
import useDebounce from '../../../hooks/useDebounce';
import PublicPage from '../../base/public';
//import PrivatePage from '../../base/private';
import Section from '../../../components/common/section';
import IntroduceForm from '../../../components/forms/introduce';

const useStyles = makeStyles({
  root: {
    '& > section:nth-child(even)': {
      backgroundColor: COLORS.grayScale[1],
    },
  },
  container: {
    maxWidth: '90rem',
    padding: '2rem 3.125rem',
  },
  loader: {
    paddingTop: '3rem',
  },
});

const AddPage = () => {
  const classes = useStyles();
  const notifications = useNotifications();
  const history = useHistory();
  //const edit = true;
  //const disabled = true;

  const handleCancel = useDebounce(() => {
    history.goBack();
  }, 1000);

  const handleAddCandidate = useDebounce((data) => {
    postCandidate({ immediately: true, ...data })
    .then((res) => {
      if(res.success) {
        history.replace(`/candidates/${res.data.hash}/edit`)
      }else {
        if(res?.error?.errors && typeof res.error.errors === 'object' && Object.values(res.error.errors).length > 0) {
          const message = Object.values(res.error.errors).map((error) => error).join(' , ')
          notifications.error({message})
        }else{
          notifications.error(res.error)
        }
        
      }
    }
    )
  }, 1000);

  return (
    <PublicPage withActions={true} onCancel={handleCancel}>
        <div className={classes.root}>
          <section>
            <Container className={classes.container}>
              <Section title="New Candidate">
                <IntroduceForm
                  onSubmit={(data) => handleAddCandidate(data)}
                />
              </Section>
              <Skills title="Skills" edit disabled/>
              <Overview edit disabled/>
            </Container>
          </section>
          <section>
            <Container className={classes.container}>
              <Experiences edit disabled/>
            </Container>
          </section>
          <section>
            <Container className={classes.container}>
              <Education edit disabled/>
              <Quotes edit disabled/>
            </Container>
          </section>
        </div>
    </PublicPage>
  );
};

export default AddPage;
